import { MILLION } from 'constants/dataSets';

import type IProfitCenterLink from 'store/slices/dataSets/interfaces/IProfitCenterLink';

const profitCenterLinksFormatted = (
  profitCenterLinksArray: IProfitCenterLink[],
) => profitCenterLinksArray.map((profitCenterLink) => ({
  ...profitCenterLink,
  totalCost: `${profitCenterLink.totalCost ? Number(profitCenterLink.totalCost.split(' ')[0]) / MILLION : 0}`,
  percentOfTotalCost: profitCenterLink.percentOfTotalCost ?? 0,
  expectedGrowthDecline: profitCenterLink.expectedGrowthDecline ?? 0,
}));

export default profitCenterLinksFormatted;
